import { gql, useMutation } from 'urql';

export const useTikTokSettingsUpdateTtoAccountMutation = () => {
  return useMutation(gql`
    mutation UpdateClientTiktokTtoAccount($params: UpdateClientTiktokTtoAccountInput!) {
      updateClientTiktokTtoAccount(params:$params) {
        clientId
        tiktokTtoAccountId
        tiktokTtoAccount{
          tiktokTtoAccountId
          accountName
          timezone
          country
          businessVerificationStatus
          adAccounts {
            name
            tiktokAdAccountId
          }
        }
        ttoCampaignSettings{
          enabled
        }
        
      }
    }
  `);
};
